export default __webpack_public_path__ + "static/media/les_edit.5055e291.svg";